import React from "react";
import { FormattedMessage } from "react-intl";

export const MarketingPage: React.FC = () => {
  return (
    <div>
      <FormattedMessage id='MarketingPage.header' />
    </div>
  );
};

export default MarketingPage;
